export default __webpack_public_path__ + "images/X9.204fdfe.png";